import { render, staticRenderFns } from "./SetStandardDialog.vue?vue&type=template&id=ecf654c2"
import script from "./SetStandardDialog.vue?vue&type=script&lang=js"
export * from "./SetStandardDialog.vue?vue&type=script&lang=js"
import style0 from "./SetStandardDialog.vue?vue&type=style&index=0&id=ecf654c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports